/**
 * Class recipes shared by the super-admin pages.
 *
 * Destructive actions are outlined red, never filled (see the UI rules): put
 * this on a `<Button variant="outline">`. Never on the default variant — it is
 * filled, and its text colour wins over the red.
 */
export const DESTRUCTIVE_OUTLINE = 'border-destructive/40 text-destructive hover:bg-destructive/5 hover:text-destructive';

/** A number that should line up in a column. */
export const NUMERIC = 'tabular-nums';
